// extracted by mini-css-extract-plugin
export var animationContainer = "_p3-0";
export var footer = "_p3-1";
export var gray = "_p3-2";
export var lineItem = "_p3-3";
export var lineItemImage = "_p3-4";
export var lineItemInfo = "_p3-5";
export var lineItemText = "_p3-6";
export var lineItems = "_p3-7";
export var modalContent = "_p3-8";
export var options = "_p3-9";
export var orderName = "_p3-a";
export var refundAmount = "_p3-b";